import { NgModule } from '@angular/core';
import {
  MzButtonModule, MzCardModule, MzCheckboxModule, MzDropdownModule, MzIconMdiModule, MzInputModule, MzProgressModule, MzSelectModule,
  MzSpinnerModule, MzSwitchModule, MzTabModule, MzToastModule, MzTooltipModule, MzValidationModule
} from 'ng2-materialize';

import { NgxPaginationModule } from 'ngx-pagination';


const modules = [ MzButtonModule,
                  MzSwitchModule,
                  MzInputModule,
                  MzCheckboxModule,
                  MzIconMdiModule,
                  MzSpinnerModule,
                  MzDropdownModule,
                  MzTooltipModule,
                  MzSelectModule,
                  MzToastModule,
                  MzTabModule,
                  MzValidationModule,
                  MzCardModule,
                  MzProgressModule,
                  NgxPaginationModule ];

@NgModule({
  exports: modules,
  imports: modules
})
export class MaterialModule {
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/material/material.module.ts